import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import BaiduMap from 'vue-baidu-map';

Vue.use(Antd);
Vue.use(BaiduMap, {
  ak: 'IKNvOo3p5G2lrDDAe4xOV5vOtx5wN0pV'
})

Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
